import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area all-projects" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "text-secondary" }
const _hoisted_8 = { class: "text-secondary" }
const _hoisted_9 = { class: "text-secondary" }
const _hoisted_10 = { class: "text-secondary" }
const _hoisted_11 = { class: "text-secondary" }
const _hoisted_12 = { class: "d-flex align-items-center gap-1" }
const _hoisted_13 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_14 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_15 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_16 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_17 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_18 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4\"><h3 class=\"mb-0\">All Tickets</h3><button class=\"btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg\" data-bs-toggle=\"offcanvas\" data-bs-target=\"#offcanvasRight\" aria-controls=\"offcanvasRight\"><span class=\"py-sm-1 d-block\"><i class=\"ri-add-line d-none d-sm-inline-block me-1\"></i><span>Add New Ticket</span></span></button></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Ticket Title"),
                _createElementVNode("th", { scope: "col" }, "Requester"),
                _createElementVNode("th", { scope: "col" }, "Assigned To"),
                _createElementVNode("th", { scope: "col" }, "Created Date"),
                _createElementVNode("th", { scope: "col" }, "Due Date"),
                _createElementVNode("th", { scope: "col" }, "Priority"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/help-desk/ticket-details",
                      class: "fw-medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.ticketTitle), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.requester), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item.assignedTo), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(item.createdDate), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(item.dueDate), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.priority), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", _hoisted_13, [
                        _createElementVNode("i", _hoisted_14, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_15, [
                        _createElementVNode("i", _hoisted_16, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_17, [
                        _createElementVNode("i", _hoisted_18, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_PaginationTwo, {
          items: "10",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}